import { render, staticRenderFns } from "./AdminAlertPlanNameList.vue?vue&type=template&id=5ebe3b30"
import script from "./AdminAlertPlanNameList.vue?vue&type=script&lang=js"
export * from "./AdminAlertPlanNameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports